/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input.form-control[_ngcontent-%COMP%]:disabled{background-color:#e3f2fd;opacity:1}.MontoIva[_ngcontent-%COMP%]{display:flex;margin-right:42px}"];
export { styles as styles };
